import React from 'react'
import { observer } from 'mobx-react'
import { Tbody, Tr } from '@chakra-ui/react'
import TableCell from './TableCell'

export interface TableBodyProps {
  data: {
    name: string
    data: any[]
  }[]
}

const TableBody = ({ data }: TableBodyProps) => {
  return (
    <Tbody>
      {data.map((row, index) => (
        <Tr key={index} bg={index % 2 === 0 ? 'brand.lightGray' : 'white'}>
          {row.data.map((cellData, dataIndex) => (
            <TableCell key={dataIndex} value={cellData} isHeader={false} />
          ))}
        </Tr>
      ))}
    </Tbody>
  )
}

export default observer(TableBody)
